import Vue from "vue";
import VueRouter from "vue-router";
import LoginRoutes from "@/modules/Login/Routes";
import DashboardRoutes from "@/modules/Dashboard/Routes";
import ConfigRoutes from '@/modules/Config/Routes'
import TravelbotRoutes from '@/modules/Travelbot/Routes'
import AuditLogRoutes from '@/modules/AuditLog/Routes'
import TarifasRoutes from '@/modules/Tarifas/Routes'
import ViajesRoutes from '@/modules/Viajes/Routes'
import AffiliatePortalRoutes from '@/modules/AffiliatePortal/Routes'
import CitySelectorRoutes from '@/modules/CitySelector/Routes'
import GeografiaRoutes from '@/modules/Geografia/Routes'
import TrackingRoutes from '@/modules/Tracking/Routes'
import FleetRoutes from '@/modules/Fleet/Routes'
import UbigeoRoutes from '@/modules/Ubigeo/Routes'
import ProvidersRoutes from '@/modules/Providers/Routes'
import ImportsRoutes from '@/modules/Imports/Routes'
import ExecutionsRoutes from '@/modules/Executions/Routes'
import WhatsAppTemplatesRoutes from '@/modules/WhatsAppTemplates/Routes'
import ExchangeRatesRoutes from '@/modules/ExchangeRates/Routes'
import TesoreriaRoutes from '@/modules/Tesoreria/Routes'
import store from "../store";
import { Alert } from "wize-admin";

Vue.use(VueRouter);

// Suppress NavigationDuplicated errors from Vue Router 3.x
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

let routes = [];

routes = routes.concat(
  LoginRoutes,
  DashboardRoutes,
  ConfigRoutes,
  TravelbotRoutes,
  AuditLogRoutes,
  TarifasRoutes,
  ViajesRoutes,
  AffiliatePortalRoutes,
  CitySelectorRoutes,
  GeografiaRoutes,
  TrackingRoutes,
  FleetRoutes,
  UbigeoRoutes,
  ProvidersRoutes,
  ImportsRoutes,
  ExecutionsRoutes,
  WhatsAppTemplatesRoutes,
  ExchangeRatesRoutes,
  TesoreriaRoutes
);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters["auth/isAuthenticated"];
  const isAffiliate = store.getters["auth/isAffiliate"];

  if (to.meta.excludeAuth) {
    if (!isAuthenticated) {
      next();
    } else {
      if (isAffiliate) {
        next({ name: "AffiliateDashboard" });
      } else {
        next({ name: "dashboard" });
      }
    }
  } else {
    if (!isAuthenticated) {
      next({ name: "login" });
    } else if (to.meta.requiresAffiliate && !isAffiliate) {
      Alert.error("No tienes acceso al portal de afiliados");
      next({ name: "dashboard" });
    } else if (!to.meta.requiresAffiliate && isAffiliate && !to.meta.excludeAuth) {
      // Affiliate trying to access admin routes
      if (to.name !== "AffiliateDashboard" && to.name !== "AffiliateRides" && to.name !== "AffiliatePassword") {
        next({ name: "AffiliateDashboard" });
      } else {
        next();
      }
    } else if (!isAffiliate && !store.getters["city/isLevelChosen"] && to.name !== "city-selector") {
      // Admin autenticado que aún no eligió nivel (Administración o ciudad) — DEF-ADM-009
      next({ name: "city-selector" });
    } else {
      next();
    }
  }
});

export default router;
